import React, { useState, useEffect, useRef } from 'react';

type ErrorInputPopUpProps = {
  active: boolean;
  message: string;
  anchorRef?: React.RefObject<HTMLElement>;
  position?:
    | 'top-start'
    | 'bottom-start'
    | 'top-center'
    | 'bottom-center'
    | 'top-end'
    | 'bottom-end';
};

const ErrorInputPopUp = (props: ErrorInputPopUpProps) => {
  const { active, message, anchorRef, position = 'top-start' } = props;
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (active) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [active]);

  useEffect(() => {
    if (!isVisible) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        anchorRef &&
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node) &&
        anchorRef.current &&
        !anchorRef.current.contains(event.target as Node)
      ) {
        setIsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible, anchorRef]);

  useEffect(() => {
    if (anchorRef && anchorRef.current) {
      const anchorElement = anchorRef.current;

      if (!anchorElement) return;

      const handleFocus = () => {
        if (active) {
          setIsVisible(true);
        }
      };

      anchorElement.addEventListener('focus', handleFocus);

      return () => {
        anchorElement.removeEventListener('focus', handleFocus);
      };
    }
  }, [anchorRef, active]);

  const classNamePosition = () => {
    const scaleClass = isVisible ? 'scale-100 after:scale-100' : 'scale-0 after:scale-0';
    switch (position) {
      // Top positions
      case 'top-start':
        return `after:left-[10px] left-[10px] right-auto after:right-auto after:top-[98%] ${scaleClass} -translate-x-0`;
      case 'top-center':
        return `after:left-[50%] after:top-[98%] after:-translate-x-[50%]`;
      case 'top-end':
        return `after:right-[10px] right-[10px] left-auto after:left-auto after:top-[98%] ${scaleClass} -translate-x-0`;
      // Bottom positions
      case 'bottom-start':
        return `after:border-[8px] after:border-transparent after:border-b-white after:drop-shadow-[0_-2px_#3b97b166] after:left-[10px] after:right-auto after:top-[-14px] left-[20px] right-auto top-[125%] bottom-auto after:-translate-x-0 ${scaleClass} -translate-x-0`;
      case 'bottom-center':
        return `after:border-[8px] after:border-transparent after:border-b-white after:drop-shadow-[0_-2px_#3b97b166] after:left-[50%] after:right-auto after:top-[-14px] after:-translate-x-[50%] top-[125%] bottom-auto`;
      case 'bottom-end':
        return `after:border-[8px] after:border-transparent after:border-b-white after:drop-shadow-[0_-2px_#3b97b166] after:right-[10px] after:left-auto after:top-[-14px] top-[125%] bottom-auto right-[20px] left-auto after:-translate-x-0 ${scaleClass} -translate-x-0`;
    }
  };

  return (
    <div
      ref={tooltipRef}
      className={`add_client_error ${isVisible ? 'active' : ''} ${classNamePosition()}`}
    >
      <span>{message || 'Required'}</span>
    </div>
  );
};

export { ErrorInputPopUp };
